import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../Utils/Bind';

export class LoadingOverlayHandle {
    @bind
    @action
    public close() {
        if (this.timeout) window.clearTimeout(this.timeout);

        this.loading = false;
    }

    @bind
    @action
    public toggle() {
        this.loading = !this.loading;
    }

    @bind
    @action
    public set(text: string, icon?: string, timeout: number = 500, customLoader?: React.ReactNode) {
        this.customLoader = customLoader;
        this.text = text;
        this.icon = icon;
        if (typeof window != 'undefined')
            this.timeout = window.setTimeout(
                action(() => (this.loading = true)),
                timeout
            );
    }

    @observable
    public timeout?: number;
    @observable
    public loading = false;
    @observable
    public icon?: string;
    @observable
    public customLoader?: React.ReactNode;
    @observable
    public text: string = 'Loading...';
}

export interface ILoadingOverlayProps {
    readonly loadingOverlayHandle: LoadingOverlayHandle;
    readonly className?: string;
}

@observer
export class LoadingOverlay extends React.Component<ILoadingOverlayProps> {
    public render() {
        return (
            <div
                className={
                    this.props.className +
                    (this.props.loadingOverlayHandle.loading ? ' loading-overlay text-center h-100' : ' d-none')
                }
            >
                <div className="fading flex-items-center h-100">
                    <div className="w-100">
                        {this.props.loadingOverlayHandle.icon && (
                            <em
                                className={
                                    this.props.loadingOverlayHandle.icon
                                        ? `fa ${this.props.loadingOverlayHandle.icon} overlay-loader mb-1`
                                        : 'fa fa-spinner overlay-loader mb-1'
                                }
                                aria-hidden="true"
                            />
                        )}
                        {this.props.loadingOverlayHandle.customLoader}
                        <br />
                        {this.props.loadingOverlayHandle.text}
                    </div>
                </div>
            </div>
        );
    }
}
